import * as S from './GettingStarted.styles'
import React, { useState, useEffect, useRef, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@material-ui/core/TextField'
import { Button } from "ui";
import { setWidgetName, deleteWidget, sendScript } from 'redux_toolkit/reducers/partner/widget/widgetSlice';
import { setNotification } from 'redux_toolkit/reducers/notification/notificationSlice';


export const GettingStarted = () => {
  const dispatch = useDispatch();
  const { list, config: selectedWidget } = useSelector(({ widget }) => widget);
  const { partnerId } = useSelector(({ userPartner }) => userPartner.userData);
  const [widgetName, setNameToWidget] = useState('');
  const [email, setEmail] = useState('');
  const script = useRef();

  const isEmail = useMemo(() => {
    return email.toLowerCase().match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
  }, [email]);

  useEffect(() => {
    selectedWidget.name && setNameToWidget(selectedWidget.name)
  }, [selectedWidget.name]);

  const disabled = useMemo(() => {
    return list.some(el => el.name === widgetName)
  }, [list, widgetName]);

  const scriptText = useMemo(() => {
    return `<script>function _0x2b5f(_0x3b8609,_0x1b7aac){var _0x5eac8f=_0x5eac();return _0x2b5f=function(_0x2b5f3c,_0x3f0354){_0x2b5f3c=_0x2b5f3c-0xdc;var _0xccbca=_0x5eac8f[_0x2b5f3c];return _0xccbca;},_0x2b5f(_0x3b8609,_0x1b7aac);}(function(_0x485c45,_0x6dd9b3){var _0x43280f=_0x2b5f,_0x4c3555=_0x485c45();while(!![]){try{var _0x5ba069=-parseInt(_0x43280f(0xe3))/0x1+parseInt(_0x43280f(0xe4))/0x2+parseInt(_0x43280f(0xe9))/0x3+parseInt(_0x43280f(0xdf))/0x4+parseInt(_0x43280f(0xde))/0x5*(-parseInt(_0x43280f(0xe2))/0x6)+-parseInt(_0x43280f(0xf2))/0x7*(parseInt(_0x43280f(0xf1))/0x8)+-parseInt(_0x43280f(0xed))/0x9*(-parseInt(_0x43280f(0xe7))/0xa);if(_0x5ba069===_0x6dd9b3)break;else _0x4c3555['push'](_0x4c3555['shift']());}catch(_0x1c79e4){_0x4c3555['push'](_0x4c3555['shift']());}}}(_0x5eac,0xc20b4),!(function(){var _0x71e2c6=_0x2b5f,_0x4531e6=window;if(!_0x4531e6[_0x71e2c6(0xec)]){var _0x15e2b1=document,_0x4a71e0=function(){var _0x55e52e=_0x71e2c6,_0x1c7cf7=_0x15e2b1[_0x55e52e(0xe5)](_0x55e52e(0xee));_0x1c7cf7['type']='module',_0x1c7cf7[_0x55e52e(0xeb)]=!![],_0x1c7cf7['id']='',_0x1c7cf7[_0x55e52e(0xea)]='${process.env.REACT_APP_SCRIPT}/_js/main.js?partner_id=${partnerId}&widget_id=${selectedWidget._id}';var _0x20c967=_0x15e2b1[_0x55e52e(0xe8)]('script')[0x0];_0x20c967[_0x55e52e(0xe1)][_0x55e52e(0xdd)](_0x1c7cf7);};'complete'===document[_0x71e2c6(0xf0)]?_0x4a71e0():_0x4531e6[_0x71e2c6(0xdc)]?_0x4531e6[_0x71e2c6(0xdc)](_0x71e2c6(0xf4),_0x4a71e0):_0x4531e6[_0x71e2c6(0xe6)](_0x71e2c6(0xf3),_0x4a71e0,![]);}else console['warn'](_0x71e2c6(0xef));}()));function _0x5eac(){var _0x40939f=['append','158795MmOoFa','499928LlsiKj','text/javascript','parentNode','6jPNtgk','1171379bvuLWN','1251694rInGzE','createElement','addEventListener','20tharbC','getElementsByTagName','3778794aszOME','src','async','_Widget','1514160GWEwNy','script','Widget\x20already\x20loaded.','readyState','2840wBaPKe','6881GZQxDH','load','onload','attachEvent'];_0x5eac=function(){return _0x40939f;};return _0x5eac();}</script>`
  }, [selectedWidget._id, partnerId]);

  return (
    <S.GettingStartedContainer>
      <S.InfoItemContainer>
        <S.InfoItemTitle>
          Embed the partner Chat widget
        </S.InfoItemTitle>
        <S.InfoItemDescription>
          Copy the following script and insert it into your website's HTML source code between the {'<head>'} tags
        </S.InfoItemDescription>
        <S.AddPartner>
          Add child partner
        </S.AddPartner>
        <S.RowContainer>
          <TextField
            size='small'
            variant='outlined'
            label='Enter name'
            value={widgetName}
            onChange={(e) => setNameToWidget(e.target.value)}
          />
          <Button
            style={{
              borderRadius: '7px',
              padding: '10px 25px',
              minWidth: 'unset'
            }}
            disabled={!widgetName || disabled}
            onClick={() => {
              dispatch(setWidgetName({ partnerId, body: {name: widgetName} }));
              setNameToWidget('default')
            }}
          >
            Add
          </Button>
          <Button
            style={{
              borderRadius: '7px',
              padding: '10px 25px',
              minWidth: 'unset'
            }}
            disabled={widgetName === 'default' || !disabled}
            onClick={() => {
              dispatch(deleteWidget({partnerId, widgetId: selectedWidget._id}));
              setNameToWidget('default')
            }}
          >
            Delete
          </Button>
        </S.RowContainer>
        <Button
          style={{
            borderRadius: '7px',
            padding: '10px 25px',
            minWidth: 'unset'
          }}
         onClick={() => {
          const range = document.createRange();
          range.selectNode(script.current);

          document.getSelection().removeAllRanges();
          document.getSelection().addRange(range);
          navigator.clipboard.writeText(document.getSelection().toString()).then(() => {
            dispatch(setNotification({type: 'script successfully copied to clipboard', message: 'success'}));
          })
          
         }}
        >
          Copy script to clipboard
        </Button>
        <S.Script 
          ref={script}
          onClick={(e) => {
            const range = document.createRange();
            range.selectNode(e.target);
            document.getSelection().removeAllRanges();
            document.getSelection().addRange(range);
        }}>
          {scriptText}
        </S.Script>
      </S.InfoItemContainer>
      <S.InfoItemContainer>
        <S.InfoItemTitle>
          Email your developer
        </S.InfoItemTitle>
        <S.InfoItemDescription>
          {"Copy the following script and insert it into your website's HTML source code between the <head> tags"}
        </S.InfoItemDescription>
        <S.RowContainer>
          <TextField
            variant='outlined'
            size='small'
            label='Email Address'
            type="email"
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button
            style={{
              margin: 0,
              borderRadius: '7px',
              padding: '10px 25px',
              minWidth: 'unset'
            }}
            disabled={!isEmail}
            onClick={() => dispatch(sendScript({ partnerId, data: {email, script: scriptText}}))}
          >
            Send
          </Button>
        </S.RowContainer>
      </S.InfoItemContainer>
    </S.GettingStartedContainer>
  )
}